module.exports = __webpack_public_path__ + "img/person-1.dace87b4.jpg";